import React, { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { CardFooter } from "react-bootstrap";
import ReportEvent from "./reportEvent.jsx";
import { newTrainingRecordMain } from "../../config/apiSPA.js";
import { useNavigate } from "react-router-dom";
import ModalConfirm from "../../components/modal/modalConfirm.jsx";
const initalEventData = {
  atmp: false,
  endDate: "",
  institution: "",
  instructor: "",
  kpi: false,
  location: "",
  remark: "",
  startDate: "",
  trainingTitle: "",
};
const modalConfirmInitalState = {
  show: false,
  text: "",
};
function TrainingReport() {
  const [eventData, setEventData] = useState(initalEventData);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(true);
  const [spinner, setSpinner] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(modalConfirmInitalState);
  const navigate = useNavigate();
  useEffect(() => {
    const isInvalid = [eventData.trainingTitle, eventData.startDate, eventData.endDate, eventData.institution, eventData.location, eventData.instructor].some((value) => !value);
    setSubmitBtnDisabled(isInvalid);
  }, [eventData]);
  const handleClickSubmit = async (val) => {
    setSpinner(true);
    try {
      const payload = {
        atmpStatus: val.atmp,
        kpiStatus: val.kpi,
        kodeTrId: val.trainingTitle,
        locationId: val.location,
        institutionId: val.institution,
        instructorId: val.instructor,
        startDate: val.startDate,
        endDate: val.endDate,
        remark: val.remark,
      };
      const res = await newTrainingRecordMain(payload);
      navigate(`/training/detail/${res.data.id}`);
    } catch (error) {
      setModalConfirm({
        show: true,
        text: `Failed create new event Training. Message: ${error.message}`,
      });
    } finally {
      setSpinner(false);
    }
  };
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="row">
              <div className="col-xl-9">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#/">Training</a>
                  </li>
                  <li className="breadcrumb-item active">New</li>
                </ul>

                <h1 className="page-header">Input New Training Data</h1>

                <hr className="mb-4" />

                <div id="formControls" className="mb-5">
                  <p>
                    Use this page to add new training data to the system. Please fill in all required fields and upload the dataset in a supported format. Accurate and well-structured data will help improve model performance and ensure
                    optimal results. Once completed, submit the form to save and process the training data.
                  </p>
                  <Card>
                    <CardBody className="pb-2">
                      <ReportEvent onUpdate={(val) => setEventData(val)} />
                    </CardBody>
                    <CardFooter>
                      {spinner ? (
                        <button type="button" className="btn btn-lg btn-outline-theme" disabled>
                          <i className="spinner-border spinner-border-sm"></i>
                        </button>
                      ) : (
                        <button onClick={() => handleClickSubmit(eventData)} type="button" disabled={submitBtnDisabled} className="btn btn-lg btn-outline-theme">
                          Submit
                        </button>
                      )}
                    </CardFooter>
                  </Card>
                </div>
              </div>
              <div className="col-xl-3"></div>
            </div>
          </div>
        </div>
      </div>
      <ModalConfirm show={modalConfirm.show} theme={"danger"} title={"Warning !!"} text={modalConfirm.text} onHide={() => setModalConfirm(modalConfirmInitalState)} clicked={() => setModalConfirm(modalConfirmInitalState)} />
    </>
  );
}

export default TrainingReport;
